module.exports = __webpack_public_path__ + "static/edu-spec-a99eeb72d6dcb0d16b17a8a59ed7bd10.png";